module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Baking-glove-5d26f06a2ba37992b11036c7a5a93602.svg";